module.exports = __webpack_public_path__ + "img/list-1.1bf7ee93.png";